import { motion } from "framer-motion";
import SectionHeading from "@/components/common/SectionHeading";
import { WHY_US } from "@/lib/data";

export default function WhyStudentsTrust() {
  return (
    <section className="py-24 sm:py-32" data-testid="why-students-trust-home">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="Why Students Trust Us"
          title="Six reasons international students choose SKVY Harmony."
          sub="From your first mock interview to your Green Card sponsorship, we're in it for the long arc."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 mt-16">
          {WHY_US.map((w, i) => (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="glass rounded-2xl p-6 glow-hover"
              data-testid={`why-us-home-${i}`}
            >
              <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4"
                style={{ background: "linear-gradient(135deg, #1E3A8A, #10B981)" }}>
                <w.icon className="w-5 h-5 text-white" />
              </div>
              <p className="font-poppins text-white font-medium text-lg mb-2">{w.title}</p>
              <p className="font-inter text-sm text-white/55">{w.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
